import NewProject from "../../components/newProject";

export default function NewProjectPage() {
	return <NewProject />;
}
